import { useEffect, useState } from "react";
import { useScreenWidth } from "../SubscriptionPageV2/hooks";
const useRetakeQuizDrawer = (quizData) => {
    const isMobile = useScreenWidth() < 968;
    const [expanded, setExpanded] = useState({});
    useEffect(() => {
        if (Object.keys(expanded).length > 0)
            return;
        quizData.forEach((item) => {
            expanded[item.title] = false;
        });
    }, [quizData]);
    return {
        isMobile,
        setExpanded,
        expanded,
    };
};
export default useRetakeQuizDrawer;
